import BuildingGradeList from "containers/property/BuildingGradeList";
import { Modal } from "react-bootstrap";

function BuildingGradeModal({
    isAuthenticated,
    user,
    show,
    onClose,
    filter,
    data,
    updateTableState,
    saveRecord,
    deleteRecord,
    buildingGradeSourceOptions,
    buildingGradeOptions,
    validateRelatedRecord,
}) {

    return (
        <Modal show={show} onHide={onClose} dialogClassName="property-table-modal-wide">
            <Modal.Header closeButton>
                <Modal.Title>Building Grades</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BuildingGradeList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table"
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                    buildingGradeSourceOptions={buildingGradeSourceOptions}
                    buildingGradeOptions={buildingGradeOptions}
                />
            </Modal.Body>
        </Modal>
    );
}
export default BuildingGradeModal;